import React from 'react';
import Header from '../../common/header/header';
import Footer from '../../common/footer/footer';
import LegalDocumentBody from '../../common/legalDocumentBody/legalDocumentBody';
import policyFile from '../../../files/Политика конфиденциальности.pdf';
import { privacyDocumentText } from '../../../data/legal/privacyText';
import classes from '../../common/legalPage/legalPage.module.css';

const PrivacyPage = () => {
  return (
    <div className={classes.page}>
      <Header />
      <main className={classes.main}>
        <section className={classes.card}>
          <h1 className={classes.title}>Политика конфиденциальности</h1>
          <p className={classes.subtitle}>
            Порядок обработки персональных данных пользователей сайта salonlev.ru
          </p>

          <div className={classes.meta}>
            <div>Оператор: ИП Лила Екатерина Сергеевна</div>
            <div>ИНН: 650803245599</div>
            <div>ОГРНИП: 325774600156114</div>
            <div>Телефон: +7 (915) 189-7033</div>
            <div>E-mail: salon.l.e.v@yandex.ru</div>
            <div>Сайт: salonlev.ru</div>
          </div>

          <a
            href={policyFile}
            download="Политика конфиденциальности.pdf"
            className={classes.download}
          >
            Скачать политику конфиденциальности (PDF)
          </a>

          <LegalDocumentBody text={privacyDocumentText} />
        </section>
      </main>
      <Footer />
    </div>
  );
};

export default PrivacyPage;
